var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: { label: "Área (ha):", content: _vm.pratica.area }
              }),
              _vm._v(" "),
              _vm.pratica.lavouras.length
                ? _c("app-display", {
                    attrs: {
                      label: "Atividades agrícolas e produtividade:",
                      content: _vm.formataLavouras(_vm.pratica.lavouras),
                      isContentInNextLine: true
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.pratica.pecuarias.length
                ? _c("app-display", {
                    attrs: {
                      label: "Tipo de criação pecuária e produtividade:",
                      content: _vm.formataPecuarias(_vm.pratica.pecuarias),
                      isContentInNextLine: true
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.pratica.florestas.length
                ? _c("app-display", {
                    attrs: {
                      label: "Espécies florestais utilizadas e produtividade:",
                      content: _vm.formataFlorestas(_vm.pratica.florestas),
                      isContentInNextLine: true
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Data de início da implementação (mês e ano):",
                  content: _vm.formataDataInicio(_vm.pratica.dataInicio)
                }
              }),
              _vm._v(" "),
              _c("app-display", {
                attrs: {
                  label: "Modalidade adotada:",
                  content: _vm.formataModalidadesAdotadas(
                    _vm.pratica.modalidades
                  )
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("Bioinsumos", {
        attrs: {
          bioinsumo: {
            utilizaBioinsumos: _vm.pratica.utilizaBioinsumos,
            bioinsumos: _vm.pratica.bioinsumos
          }
        }
      }),
      _vm._v(" "),
      _c("Irrigacao", {
        attrs: {
          irrigacao: Object.assign(
            {},
            { possuiIrrigacao: _vm.pratica.possuiIrrigacao },
            _vm.pratica.irrigacao
          )
        }
      }),
      _vm._v(" "),
      _c("Financiamento", {
        attrs: {
          financiamento: {
            financiamentos: _vm.pratica.financiamentos,
            outroFinanciamento: _vm.pratica.outroFinanciamento
          }
        }
      }),
      _vm._v(" "),
      _c("Descricao", { attrs: { descricao: _vm.pratica.descricao } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "title-praticas" }, [
        _vm._v("Dados da prática")
      ]),
      _vm._v(" "),
      _c("hr")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-068612bd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-068612bd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Praticas/ILPF/ILPF.vue
// module id = null
// module chunks = 